import { fetcher } from "helpers/fetcher";

import { TGetListCorporationReq, TGetListCorporationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListCorporation = async (payload: TGetListCorporationReq) => {
  return await fetcher<TGetListCorporationRes, TGetListCorporationReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_LIST_CORPORATION,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetListCorporation = async (
  payload: TGetListCorporationReq
) => {
  return await getListCorporation(payload);
};

queryGetListCorporation._key = (payload?: TGetListCorporationReq) => [
  ENDPOINT.MANAGEMENT.GET_LIST_CORPORATION.url,
  payload,
];
